import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Connecting.css';
import { apiService } from '../services/api';
import { API_ENDPOINTS } from '../config/apiConfig';

const Connecting = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Completing Meta connection...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setStatus('error');
      setMessage('Missing authorization details. Please retry the connection.');
      return;
    }

    const completeCallback = async () => {
      try {
        await apiService.get(API_ENDPOINTS.META_OAUTH_CALLBACK(code, state));
        setStatus('success');
        setMessage('Meta account connected. Redirecting to your dashboard...');
        window.history.replaceState(null, '', window.location.pathname);
        setTimeout(() => navigate('/dashboard'), 1500);
      } catch (error) {
        console.error('Failed to complete Meta OAuth callback:', error);
        const fallbackMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Unable to complete Meta connection. Please try again.';
        setStatus('error');
        setMessage(fallbackMessage);
      }
    };

    completeCallback();
  }, [navigate]);

  const handleRetry = () => {
    navigate('/welcome');
  };

  return (
    <div className={`connecting-container status-${status}`}>
      <div className="connecting-card">
        <div className={`connecting-spinner ${status}`} />
        <h1 className="connecting-title">
          {status === 'success'
            ? 'Meta Connected'
            : status === 'error'
            ? 'Connection Failed'
            : 'Connecting to Meta'}
        </h1>
        <p className="connecting-message">{message}</p>
        {status === 'error' && (
          <button type="button" className="connecting-retry" onClick={handleRetry}>
            Return to Post-Signup
          </button>
        )}
      </div>
    </div>
  );
};

export default Connecting;

